import hocs from 'common-hocs';
import { selectFormValues } from './selectors';
import LoginForm from './login-form.presentation';

const mapState = (state, props) => ({
  formValues: selectFormValues(state, props)
});

export default hocs({ form: {}, i18n: ['common', 'errors'], redux: { mapState } })(LoginForm)



// WEBPACK FOOTER //
// ./src/login-form/login-form.container.js